"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// status that comes from BE
exports.default = {
    CREATED: 'CREATED',
    CANCELLED: 'CANCELLED',
};
